import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CART_ACTIONS } from '@usf/ngrx-order';
import { of, combineLatest, take } from 'rxjs';
import { map, switchMap, mergeMap } from 'rxjs/operators';
import { ORDER_TRACING_ACTIONS } from '../order-tracing.actions';
import { OrderTracingService } from '../order-tracing.service';
import { CART_TRACING_ACTIONS } from './cart-tracing.actions';
import { OrderService } from '@order/services/order.service';
@Injectable({
  providedIn: 'root',
})
export class CartTracingEffects {
  traceAddToCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CART_ACTIONS.updateCart),
      mergeMap(payload => {
        return combineLatest([
          of(payload),
          this.orderService.getProductsForTracing$(payload?.order?.orderItems),
        ]).pipe(take(1));
      }),
      map(([payload, productMap]) =>
        OrderTracingService.createAddToOrderTrace(
          payload.order.orderHeader,
          payload.order.orderItems,
          productMap,
          true,
          true,
        ),
      ),
      switchMap(tracking => {
        return of(ORDER_TRACING_ACTIONS.traceAddToOrder({ tracking }));
      }),
    ),
  );

  cancelIPOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CART_ACTIONS.deleteCart),
      mergeMap(payload => {
        return combineLatest([
          of(payload),
          this.orderService.getProductsForTracing$(payload?.order?.orderItems),
        ]).pipe(take(1));
      }),
      map(([payload, products]) => {
        const trace = OrderTracingService.createCancelIPOrderTrace(
          payload,
          products,
          true,
          false,
        );
        return trace;
      }),
      switchMap(tracking => {
        return of(CART_TRACING_ACTIONS.traceCancelIPOrder({ tracking }));
      }),
    ),
  );

  cancelIPOrderSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CART_ACTIONS.deleteCartSuccess),
      mergeMap(payload => {
        return combineLatest([
          of(payload),
          this.orderService.getProductsForTracing$(payload?.order?.orderItems),
        ]).pipe(take(1));
      }),
      map(([payload, products]) => {
        const trace = OrderTracingService.createCancelIPOrderTrace(
          payload,
          products,
          false,
          true,
        );
        return trace;
      }),
      switchMap(tracking => {
        return of(CART_TRACING_ACTIONS.traceCancelIPOrderSuccess({ tracking }));
      }),
    ),
  );

  cancelIPOrderFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CART_ACTIONS.deleteCartFail),
      mergeMap(payload => {
        return combineLatest([
          of(payload),
          this.orderService.getProductsForTracing$(payload?.order?.orderItems),
        ]).pipe(take(1));
      }),
      map(([payload, products]) => {
        const trace = OrderTracingService.createCancelIPOrderTrace(
          payload,
          products,
          false,
          true,
        );
        return trace;
      }),
      switchMap(tracking => {
        return of(CART_TRACING_ACTIONS.traceCancelIPOrderFail({ tracking }));
      }),
    ),
  );

  cancelIPOrderWithErrorDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CART_ACTIONS.deleteCartWithErrorDetails),
      mergeMap(payload => {
        return combineLatest([
          of(payload),
          this.orderService.getProductsForTracing$(payload?.order?.orderItems),
        ]).pipe(take(1));
      }),
      map(([payload, products]) => {
        const trace = OrderTracingService.createCancelIPOrderTrace(
          payload,
          products,
          false,
          true,
        );
        return trace;
      }),
      switchMap(tracking => {
        return of(CART_TRACING_ACTIONS.traceCancelIPOrderFail({ tracking }));
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private orderService: OrderService,
  ) {}
}
